import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { identificationTypeColumns } from "../../../../data/Columns/SystemSetupColumns";
import { identificationType } from "../../../../data/Queries/SetupManagement/SystemSetupQueries";
import { setupManagementUrl } from "../../../../config";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import IdentificationForm from "./Form";



const base_url = setupManagementUrl.uri;
const actions = {
  entity: "Identification",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
};
function IdentificationTypes() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Courts"
          subtitle="Manage Courts"
          columns={identificationTypeColumns}
          FormComponent={IdentificationForm}
          query={identificationType}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default IdentificationTypes;